// extracted by mini-css-extract-plugin
module.exports = {"base":"BenefitsStageboxDetail-module-base","content":"BenefitsStageboxDetail-module-content","icon":"BenefitsStageboxDetail-module-icon"};